import React from "react";

/**
 * Quote — testimonial card for the marketing pages.
 *
 * Editorial look: oversized display-italic open-quote glyph, a blockquote,
 * an attribution footer. Shared by `Landing.js` and `PetsLanding.js` so
 * both pages feel like one brand. Composite characters live in each page
 * — we intentionally don't bundle quote data with this component since
 * the copy varies by story.
 */
export function Quote({ body, attribution, testId }) {
  return (
    <figure
      className="rounded-xl border border-[color:var(--line-soft)] bg-[color:var(--surface)] p-5 md:p-6 flex flex-col gap-4"
      data-testid={testId}
    >
      <div
        aria-hidden="true"
        className="font-display-italic text-4xl leading-none text-[color:var(--ink-3)]"
      >
        “
      </div>
      <blockquote className="text-[14px] md:text-[15px] text-[color:var(--ink)] leading-relaxed">
        {body}
      </blockquote>
      <figcaption className="label-tiny text-[color:var(--ink-3)] leading-snug">
        {attribution}
      </figcaption>
    </figure>
  );
}
